export default __webpack_public_path__ + "static/media/p2023-25.d55ef77c.jpeg";